import { render, staticRenderFns } from "./EditarDadoEntidade.vue?vue&type=template&id=568b185e&"
import script from "./EditarDadoEntidade.vue?vue&type=script&lang=js&"
export * from "./EditarDadoEntidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VEditDialog,VTextField})
